import { MENU_LIST_ITEM_STATUSES } from '@/utils/constants';
import DisplayedTimeFormat from '../DisplayedTimeFormat/DisplayedTimeFormat.vue';
import MemberOrders from '../MemberOrders/MemberOrders.vue';
import PeriodsDisplay from '../PeriodsDisplay/PeriodsDisplay.vue';

export default {
  name: 'MenuTopInfos',
  components: {
    DisplayedTimeFormat,
    MemberOrders,
    PeriodsDisplay,
  },
  props: {
    infos: {
      required: true,
      type: Object,
    },
    memberOrders: {
      default: () => [],
      type: Array,
    },
    showAuthInfos: {
      default: false,
      type: Boolean,
    },
    timePeriods: {
      required: true,
      type: Array,
    },
  },
  computed: {
    allowedReceivePeriods() {
      return this.infos?.allowed_receive_periods || [];
    },
    isScheduled() {
      return this.infos?.status === MENU_LIST_ITEM_STATUSES.SCHEDULED;
    },
  },
};
